import { EventItemCreditType } from './event-item-credit-type.model';
import { EventItemAffCode } from './event-item-aff-code.model';
//import moment from 'moment-es6';
import { MomentService } from '../../../shared/moment/moment.service';

export class EventItemEdit {
  public EventItemId: number;
  public EventId: number;
  public DateCreated: Date;
  public DateChanged: Date;
  public ItemNum: number;
  public UnitPrice: number;
  public BasePrice: number;
  public FlatFee: number;
  public Descr: string;
  public AttendeesForItem: number;
  public Taxable: boolean;
  public IsPublic: boolean;
  public IsSponsorShip: boolean;
  public MaxItemsAvail: number;
  public LimitPerRegistration: number;
  public InvoiceDateDue: Date;
  public SurveyId: number;
  public AttachSurveyTo: number;
  public MembersOnly: boolean;
  public RestrictForAffiliations: boolean;
  public Expires: boolean;
  public StartDate: Date;
  public EndDate: Date;
  public ShowAsTeaserifRestricted: boolean;
  public TeaserMessage: string;
  public RestrictedMessage: string;
  public MemberPrice: number;
  public NonMemberPrice: number;
  public AllowRelateProfileMemberPrice: boolean;
  public HasSale: boolean;
  public SaleStartDate: Date;
  public SaleEndDate: Date;
  public DisplayOrder: number;
  public HasMemberPricing: boolean;
  public PaymentTypeId: number;
  public StartTime: string;
  public EndTime: string;
  public ShowForEligibleUsersOnly: boolean;
  public DefaultAdjustmentTypeId: number;
  public Sold: number;
  public Remaining: number;
  public CreateSeparateAttendee: boolean;

  public AmountInvoiced: number;
  public AmountPaid: number;
  public AmountDue: number;
  public LongDescription: string;
  public UseRegistrationDateForInvoiceDueDate: boolean;
  public DaysAfterRegistrationDateForInvoiceDueDate: number;

  public AffCodes: Array<string>;
  public CreditTypes: Array<EventItemCreditType> = [];
  public AffCodeRestrictions: Array<EventItemAffCode>;

  private _momentService: MomentService;

  public constructor() {
    this._momentService = new MomentService();

    this.EventItemId = 0;
    this.EventId = 0;
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.ItemNum = 0;
    this.UnitPrice = 0;
    this.BasePrice = 0;
    this.FlatFee = 0;
    this.Descr = '';
    this.AttendeesForItem = 0;
    this.Taxable = false;
    this.IsPublic = false;
    this.IsSponsorShip = false;
    this.MaxItemsAvail = 0;
    this.InvoiceDateDue = this._momentService.getMoment().startOf('day').toDate();
    this.SurveyId = 0;
    this.AttachSurveyTo = 0;
    this.MembersOnly = false;
    this.RestrictForAffiliations = false;
    this.Expires = false;
    this.StartDate = this._momentService.getMoment().startOf('day').toDate();
    this.EndDate = this._momentService.getMoment().startOf('day').toDate();
    this.ShowAsTeaserifRestricted = false;
    this.TeaserMessage = '';
    this.RestrictedMessage = '';
    this.MemberPrice = 0;
    this.NonMemberPrice = 0;
    this.AllowRelateProfileMemberPrice = false;
    this.HasSale = false;
    this.SaleStartDate = this._momentService.getMoment().startOf('day').toDate();
    this.SaleEndDate = this._momentService.getMoment().startOf('day').toDate();
    this.DisplayOrder = 0;
    this.HasMemberPricing = false;
    this.PaymentTypeId = 0;
    this.StartTime = '';
    this.EndTime = '';

    this.Sold = 0;
    this.Remaining = 0;

    this.CreateSeparateAttendee = false;

    this.AmountInvoiced = 0;
    this.AmountPaid = 0;
    this.AmountDue = 0;

    this.AffCodes = new Array<string>();
    this.AffCodeRestrictions = new Array<EventItemAffCode>();

    this.ShowForEligibleUsersOnly = false;

    this.LongDescription = '';
    this.UseRegistrationDateForInvoiceDueDate = false;
    this.DaysAfterRegistrationDateForInvoiceDueDate = 0;
  }
}
